module.exports = __webpack_public_path__ + "media/iwd.fbddcd36.mp4";